var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useInput, useRecordContext, useResourceContext, } from 'react-admin';
import get from 'lodash/get';
import { useMemo } from 'react';
import { getRCTree } from '../util';
import { useTreeChoicesContext } from '../reference';
export var useTreeInputController = function (props) {
    var sourceProp = props.source, treeDataProp = props.treeData, hideRootNodes = props.hideRootNodes, _a = props.titleField, titleField = _a === void 0 ? 'title' : _a, rest = __rest(props, ["source", "treeData", "hideRootNodes", "titleField"]);
    var resource = useResourceContext(props);
    var record = useRecordContext(props);
    var _b = useTreeChoicesContext(), sourceFromContext = _b.source, treeDataFromContext = _b.treeData, isLoading = _b.isLoading, isFetching = _b.isFetching, error = _b.error;
    var treeData = treeDataProp !== null && treeDataProp !== void 0 ? treeDataProp : treeDataFromContext;
    var source = sourceProp !== null && sourceProp !== void 0 ? sourceProp : sourceFromContext;
    // prepare data structure for rc-tree
    // add key and title, and turn to recursive DataNode[] format
    var tree = useMemo(function () {
        return treeData
            ? getRCTree(treeData, titleField, undefined, hideRootNodes)
            : null;
    }, [treeData, hideRootNodes, titleField]);
    var _c = useInput(__assign(__assign({}, rest), { resource: resource, source: source, type: 'text' })), isRequired = _c.isRequired, field = _c.field, fieldState = _c.fieldState, formState = _c.formState;
    var defaultValue = get(record, source, props.defaultValue);
    return {
        resource: resource,
        source: source,
        tree: tree,
        fetchError: error,
        isLoading: isLoading,
        isFetching: isFetching,
        isRequired: isRequired,
        field: field,
        fieldState: fieldState,
        formState: formState,
        defaultValue: defaultValue,
    };
};
